import { render, staticRenderFns } from "./DashAsideLeft.vue?vue&type=template&id=487e42bb&scoped=true"
import script from "./DashAsideLeft.vue?vue&type=script&lang=ts"
export * from "./DashAsideLeft.vue?vue&type=script&lang=ts"
import style0 from "./DashAsideLeft.vue?vue&type=style&index=0&id=487e42bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487e42bb",
  null
  
)

export default component.exports